/* eslint-disable */
import React, { useEffect, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import { dateFr } from '../../utils/helper';
import { datesFormatedForRequest, inputTextDate, loaderForGraphics, renderSwitchButtons } from '../../utils/helpers/view/detailsHelper';
import { createGlobalStyle } from 'styled-components';
import ModernDatePicker from '../../components/common/component/ModernDatePicker';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import { EcpDetailApi, H2sDetailApi } from '../../utils/api';
import { fetchPov } from '../DetailHelper';
import {
  dateFormatedForRequest,
  formatedPluvioDataForDailyAndMonthlyGraphics,
  h2sGraphicsLegend,
  initDates,
} from '../../utils/helpers/view/ecpDetailHelper';
import H2sChartComponent from './H2sChartComponent';
import { getMaxValue } from '../../utils/helpers/view/chartsComponentHelper';
import {
  formatedDataForTable,
  formatedDataForH2sDetailGraphics,
  LegendColors,
  switchDataLegendToShow
} from '../../utils/helpers/view/h2sDetailHelper';
import MaterialTableComponent from '../../components/module/table/materialTableComponent';
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import ExportTable from '../../components/common/component/ExportTable';
import { ecpDetailColumns } from '../../utils/helpers/table/tableHelper';
import { InputSwitch } from 'primereact/inputswitch';

interface TabProps {
  id: number;
  label: string;
  active: boolean;
  setter: Function;
  trigger?: Function;
  filter?: string;
  legend?: string[];
}

interface ECPDetailProps {
  row: any;
  IsVisible: boolean;
}

const H2sDetail = (props: ECPDetailProps) => {
  const contractLabel = window.sessionStorage.getItem('contractLabel');
  // datepicker
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  // show or hide buttons/tabs
  const [showPluvio, setShowPluvio] = useState(false);
  // data for line and histogramme charts
  const [dataLegend, setDataLegend] = useState<any>(null);
  const [tableData, setTableData] = useState<any>(null);
  const [allData, setAllData] = useState<any>(null);
  const [pluvioData, setPluvioData] = useState<any>(null);
  const sessionId = window.sessionStorage.getItem('contractId')!;
  const [idPov, setIdPov] = useState<string | null>(null);

  // Gestion des onglets principaux avec un seul state
  const [mainTabsStates, setMainTabsStates] = useState<TabProps[]>([
    { id: 0, label: 'Graphique', active: true, setter: () => {} },
    { id: 1, label: 'Tableau', active: false, setter: () => {} },
  ]);

  // Gestion des onglets secondaires avec un seul state
  const [secondTabsStates, setSecondTabsStates] = useState<TabProps[]>([
    { 
      id: 0,
      label: 'Boon&Lister',
      active: true,
      setter: () => {},
      filter: 'boonlister',
      legend: [],
    },
    {
      id: 1,
      label: 'Tps séjour cana',
      active: false,
      setter: () => {},
      filter: 'tscr',
      legend: [],
    },
    { 
      id: 2,
      label: 'Tps séjour PR',
      active: false,
      setter: () => {},
      filter: 'tspr',
      legend: [],
    },
    { 
      id: 3,
      label: 'Vit autocurage',
      active: false,
      setter: () => {},
      filter: 'tautocur',
      legend: [],
    },
  ]);

  const getIndicators = async (
    pRow: any,
    dates: any,
  ) => {
    try {
      // Clear existing data to prevent stale state
      setAllData(null);
      setTableData(null);
      setDataLegend(null);
      
      const allData = await H2sDetailApi.getDetailData(
        sessionId,
        pRow.Code,
        dates.startDate,
        dates.endDate
      );
      const dataForTable = formatedDataForTable(allData.data.chartData);
      const dataToShow = formatedDataForH2sDetailGraphics(
        allData.data.chartData,
        secondTabsStates
      );
      setAllData(dataToShow);
      setTableData(dataForTable);
      setDataLegend(allData.data.parametersDetail);
    } catch (e) {
      console.log('Aucune donnée H2S remontée !', e);
      setAllData(secondTabsStates.map(tab => ({ label: tab.label, data: null })));
      setTableData([]);
      setDataLegend([]);
    }
  };

  const getPluvio = async (
    pRow: any,
    pluvioDates: any,
  ) => {
    try {
      const pluvioData = await EcpDetailApi.getDailyPluvioDataAtLimitPoint(
        pRow.Code,
        pluvioDates.startDate,
        pluvioDates.endDate
      );
      let dataToShow = formatedPluvioDataForDailyAndMonthlyGraphics(
        pluvioData.data
      );
      setPluvioData(dataToShow);
    } catch (e) {
      console.log('Aucune donnée pluviométrique remontée !', e);
      setPluvioData([]);
    }
  };

  useEffect(() => {
    initDates().then((dates) => {
      setStartDate(dates.start);
      setEndDate(dates.end);
      const datesForRequests = dateFormatedForRequest(dates, '');
      const pluvioDates = dateFormatedForRequest(dates, 'pluvio');
      getIndicators(props.row, datesForRequests);
      getPluvio(props.row, pluvioDates);
    });
  }, []);

  // Add effect to refresh data when H2S indicator changes
  useEffect(() => {
    if (startDate !== null && endDate !== null) {
      const datesForRequests = dateFormatedForRequest({ start: startDate, end: endDate }, '');
      getIndicators(props.row, datesForRequests);
    }
  }, [window.sessionStorage.getItem('h2s_indicator')]);

  // Mise à jour des légendes quand dataLegend change
  useEffect(() => {
    fetchPov(props.row.Code).then((pov) => setIdPov(pov));
    if (dataLegend !== null) {
      setSecondTabsStates(prevStates => 
        prevStates.map(tab => ({
          ...tab,
          legend: tab.filter === 'boonlister' 
            ? switchDataLegendToShow(dataLegend, 'boonLister', 'mg/L', '<', '>')
            : tab.filter === 'tscr'
            ? switchDataLegendToShow(dataLegend, 'residenceTime', 'h', '<', '>')
            : tab.filter === 'tspr'
            ? switchDataLegendToShow(dataLegend, 'posteResidenceTime', 'dem/j', '>', '<')
            : tab.filter === 'tautocur'
            ? switchDataLegendToShow(dataLegend, 'selfCleansing', 'm/s', '>', '<')
            : tab.legend
        }))
      );
    }
  }, [dataLegend]);

  const launchRequests = () => {
    if (startDate !== null && endDate !== null) {
      setAllData(null);
      setTableData(null);
      setShowPluvio(false);
      const datesForRequests = datesFormatedForRequest(startDate, endDate);
      getIndicators(props.row, datesForRequests.dataDates);
      getPluvio(props.row, datesForRequests.pluvioDates);
      fetchPov(props.row.Code).then((pov) => setIdPov(pov));
    }
  };

  const data = allData !== null ? (allData.find((d) => d.label === secondTabsStates.find((l) => l.active === true)?.label)?.data ?? []) : [];

  return (
    <>
      <Styles />
      {/* Header */}
      <div
        className='sds-reset-style'
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingTop: '10px',
        }}
      >
        <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
          <Word value={props.row.Description} variant='h5' />
        </div>
        {/* Title : name of installation */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '98%',
            gap: '40px',
            marginBottom: '1%'
          }}
        >
          <div style={{ display: 'contents' }}>
            <div style={{ display: 'inline-flex' }}>
              <div style={{ display: 'block', marginRight: '10px' }}>
                <Word value='Début' />
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '45px',
                    backgroundColor: '#ECF1F8',
                  }}
                >
                  <ModernDatePicker
                    className='datePickFrom'
                    inputPlaceholder='Début'
                    value={startDate}
                    shouldHighlightWeekends
                    formatInputText={() => {
                      return inputTextDate(startDate);
                    }}
                    locale={dateFr}
                    onChange={(date: any) => {
                      setStartDate(date);
                    }}
                  />
                </div>
              </div>
              <div style={{ display: 'block', marginRight: '10px' }}>
                <Word value='Fin' />
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '45px',
                    backgroundColor: '#ECF1F8',
                  }}
                >
                  <ModernDatePicker
                    className='datePickFrom'
                    inputPlaceholder='Fin'
                    value={endDate}
                    shouldHighlightWeekends
                    formatInputText={() => {
                      return inputTextDate(endDate);
                    }}
                    locale={dateFr}
                    onChange={(date: any) => {
                      setEndDate(date);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* Search data */}
          <div style={{
            display: 'flex',
            justifyContent: 'flex-start',
            width: 'inherit',
          }}>
            <Button className={'button'} mode='basic' onClick={launchRequests}>
              <Word variant='span' textStyle='normalBold' value={'Rechercher'} />
            </Button>
          </div>
          {/* switch buttons */}
          {renderSwitchButtons(mainTabsStates, setMainTabsStates)}
        </div>
      </div>
      {/* Menu */}
      <div
        style={{
          marginBottom: '5px',
          marginTop: '5px',
        }}
      >
        <div
          style={{
            display: 'inline-flex',
            width: '100%',
            justifyContent: 'center',
            gap: '40px',
          }}
        >
          {mainTabsStates[0].active === true && (
            <>
              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  gap: '10px',
                }}
              >
                <InputSwitch
                  id='pluvio-switch'
                  checked={showPluvio}
                  onChange={(e) => {
                    setShowPluvio(e.value ?? false);
                  }}
                />
                <Word
                  variant='p'
                  textStyle='normalBold'
                  value={'Pluviométrie en mm'}
                />
              </div>

              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  gap: '10px',
                }}
              >
                <Word
                  textStyle='normalReg'
                  variant='span'
                  value={idPov ? 'POV :' : ''}
                />
                <Word
                  variant='p'
                  textStyle='normalBold'
                  value={idPov ? idPov.toString() : ''}
                />
              </div>
            </>
          )}

          {/* switch buttons */}
          <Container
            className='button-container'
            style={{ display: mainTabsStates[0].active ? 'flex' : 'none' }}
          >
            {renderSwitchButtons(secondTabsStates, setSecondTabsStates)}
          </Container>
        </div>
      </div>
      {/* Body */}
      <div
        style={{
          display: mainTabsStates[0].active ? 'inline-block' : 'none',
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            height: '70vh',
            width: '100%',
            justifyContent: 'center',
          }}
        >
          {allData !== null && data !== undefined && (data.length > 0 || (showPluvio && pluvioData !== null && pluvioData.length > 0)) && (
            <H2sChartComponent
              data={data}
              display='100%'
              dataMaxValue={data.length > 0 ? getMaxValue(data, 'y', 'positive') : 0}
              colorsLegend={['red']}
              pluvioMax={pluvioData !== null && pluvioData.length > 0 ? getMaxValue(pluvioData, 'y', 'positive') : 0}
              pluvioData={pluvioData}
              showPluvio={showPluvio}
            />
          )}
          {((data !== null && data.length === 0) && (!showPluvio || pluvioData === null || pluvioData.length === 0)) && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Word
                variant='span'
                textStyle='normalBold'
                value='Aucune données'
              />
            </div>
          )}
          {allData === null && loaderForGraphics('170vh', '100%','loaderH2sIndicator')}
        </div>
        <div>
          {(allData !== null && data !== undefined) &&
            h2sGraphicsLegend(
              LegendColors,
              (
                data !== null &&
                Array.isArray(secondTabsStates.find((l) => l.active === true)?.legend)
                  ? secondTabsStates.find((l) => l.active === true)?.legend as string[]
                  : []
              )
            )}
        </div>
      </div>
      <div
        style={{
          display: mainTabsStates[0].active ? 'none' : 'flex',
          width: '100%',
          justifyContent: 'center',
        }}
      >
        <div style={{ width: '170vh' }}>
          {tableData !== null && (
            <Card>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  paddingRight: '20px',
                }}
              >
                <ExportTable
                  data={tableData}
                  type={'h2s-detail'}
                  contractLabel={contractLabel!}
                />
              </div>
              <MaterialTableComponent
                columns={ecpDetailColumns}
                rows={tableData}
                rowsPerPage={20}
              />
            </Card>
          )}
          {(tableData !== null && tableData.length === 0) && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Word
                variant='span'
                textStyle='normalBold'
                value='Aucune données'
              />
            </div>
          )}
          {tableData === null && loaderForGraphics('170vh', '65vh','loaderH2sIndicator')}
        </div>
      </div>
      <br />
    </>
  );
};

const Styles = createGlobalStyle`
.sds-reset-style{
  .loaderH2sIndicator {
    width: 28px;
    height: 28px;
    border: 5px solid #FFF;
    border-bottom-color: #243977;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  } 
  .button {
    color: #232323;
    background-color: #63d1b5;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    border-radius: 25px;
    cursor: pointer;
    padding: 10px 20px;
  }
  #pluvio-switch{
      vertical-align: middle;
    }
  .p-inputswitch{
    width: 48px;
    height: 28px;
   .p-inputswitch-slider:before {
    width: 20px;
    height: 20px;
    left: 4px;
    margin-top: -10px;
    }
  }
  .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before {
    -webkit-transform: translateX(18px);
    transform: translateX(18px);
  }
}
`;

export default H2sDetail;
